import { connect } from 'react-redux'
import OrganisationFiles from './organisation-files'
import {
  fetchOrganisationFiles,
  filterToBenchmarked,
  filterToAll
} from '../../../../stores/organisation-files/organisation-files.actions'
import {
  getFetchOrganisationFilesRequest,
  getOrganisationFiles,
  getBenchmarkFilter
} from '../../../../stores/organisation-files/organisation-files.selectors'

const mapStateToProps = state => {
  const fetchOrganisationFilesRequest = getFetchOrganisationFilesRequest(state)
  const organisationFiles = getOrganisationFiles(state)
  const benchmarkFilter = getBenchmarkFilter(state)
  return {
    noOrganisationFiles: organisationFiles && !organisationFiles.result.length,
    pending: !organisationFiles || fetchOrganisationFilesRequest.pending,
    benchmarkFilter
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: () => {
    dispatch(filterToAll())
    return dispatch(fetchOrganisationFiles())
  },
  onSelect: (e, benchmarkFilter) => {
    e === 'benchmarked' && dispatch(filterToBenchmarked())
    e === 'all' && dispatch(filterToAll())
    return dispatch(fetchOrganisationFiles(e === 'benchmarked'))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganisationFiles)
